"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const MenuList = props => {
  const {
    children,
    position,
    isOpen,
    stylesOverride
  } = props;
  return (0, jsx_runtime_1.jsx)(styles_1.StyledList, {
    position: position,
    isOpen: isOpen,
    stylesOverride: stylesOverride,
    children: children
  });
};
exports.default = MenuList;